import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./Report.scss";
import ResultsSpider from "../../components/Spider/ResultsSpider";
import { connect } from "react-redux";
import { gsap } from "gsap";
import ClipboardJS from "clipboard";
import Gate1 from "./../../components/Gate/Gate1";
import Gate from "./../../components/Gate/Gate";

import * as actionCreators from "../../store/actions/index";

import jsonData from "./report.json";
import DynamicAssets from "../../components/DynamicAssets/DynamicAssets";

//animations
let total = 0;
let TotalScore = 0;

let currentLabel = "";
let labelArray = [];

const Report = (props) => {
  const demoHanldr = () => {
    props.onToggleDemo();
  };

  $("html").addClass("show");
  const search = window.location.search;
  const searchURL = window.location.search;
  const params = new URLSearchParams(search);
  let gateOff = params.get("gateoff");
  let linkedInSearchURL = searchURL.replace(/\b(=)\b/g, (match) => "%3D");
  linkedInSearchURL = linkedInSearchURL.replace(/\b(&)\b/g, (match) => "%26");

  const showGate = gateOff ? null : <Gate />;

  const ANSWERS_MAP = {
    25: 0,
    50: 33,
    75: 66,
    100: 100,
  };

  useEffect(() => {
    let role = props.rol;

    props.onChooseQuestions(role, "English");
    props.onInitScores(props.scrs);
    function updateSummary() {
      $("#executive-summary").html("");
      let summary_content = "";
      var summary_level = jsonData.summary[0].low;

      if (TotalScore > 25) {
        summary_level = jsonData.summary[0].med;
        if (TotalScore > 50) {
          summary_level = jsonData.summary[0]["med-high"];
          if (TotalScore > 75) {
            summary_level = jsonData.summary[0].high;
          }
        }
      }
      $.each(summary_level, function (index, value) {
        summary_content += value;
      });

      $("#executive-summary").append(summary_content);
      new ClipboardJS(".copy-btn");
      currentLabel = $("dynamic-content-label-0").text();
    }

    for (var i = 0; i < props.scrs.length; i++) {
      //const ans_temp = ANSWERS_MAP[props.scrs[i]];
      const ans_temp = props.scrs[i];
      total += ans_temp;
      TotalScore = Math.round(total / props.scrs.length);
      if (i === props.scrs.length - 1) {
        setTimeout(function () {
          const obj = document.getElementById("user-score");
          arrangeElements();
          updateSummary();
          cloudAnimations();
          animateNumbers(obj, 0, TotalScore, 1500);
          $(".dynamic-content-text-0").height(
            $(".dynamic-content-text--1-0").height()
          );
        }, 1000);
      }
    }
  }, []);

  window.onresize = arrangeElements;

  function arrangeElements() {
    if (window.innerWidth < 1025) {
      $(".cloud-animation").detach().appendTo(".mobile-cloud-holder");
      $(".report-section-graph").detach().appendTo(".mobile-spider-holder");
      $(".report-section-footer-content")
        .detach()
        .appendTo(".report-section-footer .report__content");
    } else {
      $(".report-section-graph")
        .detach()
        .appendTo(".report-section-spider .report__content-right");
      $(".social-links")
        .detach()
        .appendTo(".report-section-footer .report__content");
      $(".cloud-animation")
        .detach()
        .appendTo(".report-section-hero .report__content-right");
    }
  }
  function confirmCopy() {
    $(".next-step-confirm").addClass("visible");
    setTimeout(function () {
      $(".next-step-confirm").removeClass("visible");
    }, 1000);
  }

  function cloudAnimations() {
    var h = 209;
    if (window.innerWidth < 1024) {
      h = 120.3;
    }
    let backgroundHeight = (TotalScore / 100) * h;
    $("#cloud-anim-background").css("height", TotalScore + "%");
    $("#numbers-holder").css("bottom", backgroundHeight + "px");
  }

  function animateNumbers(obj, start, end, duration) {
    //console.log('obj:' + obj);
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const spiderLabelClickHandlr = (lablName) => {
    const changeLabel = () => {
      $(".dynamic-content-label-0").text(lablName);
      currentLabel = lablName;
    };

    const checkHeight = () => {
      $(".dynamic-content-text-0").height(
        $(".dynamic-content-text--1-0").height()
      );
    };

    const changeText = () => {
      $(".dynamic-content-text--1-0").text(
        jsonData.capabilitiesx[lablName.toLowerCase()]
      );
    };

    gsap.to(`.dynamic-content-label-0`, {
      opacity: 0,
      x: 10,
      duration: 0.5,
      onComplete: changeLabel,
    });

    gsap.to(`.dynamic-content-text--1-0`, {
      opacity: 0,
      x: 10,
      duration: 0.5,
      onComplete: changeText,
    });

    gsap
      .to(`.dynamic-content-label-0`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
      })
      .delay(0.75);

    gsap
      .to(`.dynamic-content-text--1-0`, {
        x: 0,
        opacity: 1,
        duration: 0.5,
        onStart: checkHeight,
      })
      .delay(0.75);
  };

  const dynamixTxtContentCap = () => {
    const retThis0 = [
      <React.Fragment>
        <div
          className={`dynamic-content-label dynamic-content-label-${0}`}
          id="dynamic-label"
          key={`d1-${0}`}
        >
          {props.currentLabels[0]}
        </div>
        <div
          className={`dynamic-content-text dynamic-content-text-${0}`}
          key={`d2-${0}`}
        >
          <p
            className={`dynamic-content-text--1 dynamic-content-text--1-${0}`}
            key={`d3-${0}`}
          >
            {jsonData.capabilitiesx[props.currentLabels[0].toLowerCase()]}
          </p>
        </div>
        <div
          className="dynamic-content-hr dynamic-content-hr-0"
          key={`d4-${0}`}
        ></div>
      </React.Fragment>,
    ];

    const retThis1 = props.currentLabels.map((e, i) => {
      console.log(props.currentLabels[i]);
      return (
        <React.Fragment>
          <div
            className={`dynamic-content-label dynamic-content-label-${i + 1}`}
            id="dynamic-label"
            key={`d1-${i + 1}`}
          >
            {props.currentLabels[i]}
          </div>
          <div
            className={`dynamic-content-text dynamic-content-text-${i + 1}`}
            key={`d2-${i + 1}`}
          >
            <p
              className={`dynamic-content-text--1 dynamic-content-text--1-${
                i + 1
              }`}
              key={`d3-${i + 1}`}
            >
              {jsonData.capabilitiesx[props.currentLabels[i].toLowerCase()]}
            </p>
          </div>
          <div
            className={`dynamic-content-hr dynamic-content-hr-${i + 1}`}
            key={`d4-${i + 1}`}
          ></div>
        </React.Fragment>
      );
    });

    return retThis0.concat(retThis1);
  };

  return (
    <div className="report">
      {/*showGate*/}
      {/*<Gate1 />*/}
      <section className="report-section report-section-hero">
        <div className="report__content ">
          <div className="report__content-left">
            <div className="report-section-hero-logo"></div>
            <h3>RESULTS REPORT</h3>
            <hr class="Landing__hr"></hr>
            <h1 className="Landing__title">
              The path to
              <br />
              CX excellence for commerce
            </h1>
            <div className="mobile-cloud-holder"></div>
            <div id="executive-summary"></div>
          </div>
          <div className="report__content-right relative">
            <div className="cloud-animation">
              <div className="cloud-animation-numbers" id="numbers-holder">
                <div className="cloud-animation-number" id="user-score"></div>
                <div className="cloud-animation-number">/100</div>
              </div>
              <div
                className="cloud-animation-image-2"
                id="cloud-anim-background"
              ></div>
              <div className="cloud-animation-image-1"></div>
              <div className="cloud-animation-label">
                Overall Commerce Success score
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-spider">
        <div className="report__content">
          <div className="report__content-left">
            <div className="report-section-header">
              Capabilities and resources
            </div>

            <div className="mobile-spider-holder"></div>
            <div className="dynamic-content">
              {dynamixTxtContentCap()}
              <DynamicAssets role={props.rol} />
            </div>
          </div>
          <div className="report__content-right">
            <div className="report-section-graph">
              <ResultsSpider
                spdrlblclick={spiderLabelClickHandlr}
                labelArray={props.currentLabels}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-summary">
        <div className="report__content">
          <div className="report__content-left">
            <div className="report-section-header">Next steps</div>
            <div className="report-section-summary-content">
              <p>
              By exploring new channels and technologies, your company can enable your commerce solution to deliver an experience that’s compelling and consistent across every device and interaction.
              </p>
              <p>
              Creating a self-service, personalized commerce approach with the customer supported at every touch point is essential to company success in an increasingly digital environment. By innovating with emerging channels and capabilities and creating highly differentiated customer experiences, you become a market leader that has customers actively advocating for you and coming back for more.
              </p>
              <p>
                For more information on Oracle’s Commerce solution, visit:{" "}
                <a href="https://www.oracle.com/cx/ecommerce/" target="_blank">
                  https://www.oracle.com/cx/ecommerce/
                </a>
                .
              </p>
            </div>
          </div>
          <div className="report__content-right">
            <div className="next-steps">
              <div className="next-step next-step-left">
                <div className="next-step-icon next-step-icon-demo"></div>
                <div className="next-step-label">Request a demo</div>
                <div className="next-step-text cheat-wide">
                  See what Oracle Commerce can do for you.{" "}
                </div>
                <a
                  className="next-step-btn"
                  href="https://www.oracle.com/elq-demo-form.html?qt=saas_cx_fam"
                  target="_blank"
                  tabindex="6"
                >
                  Request a demo
                </a>
              </div>

              <div className="next-step next-step-top ">
                <div className="next-step-icon next-step-icon-tour"></div>
                <div className="next-step-label">Take a tour</div>
                <div className="next-step-text">
                  Explore <br /> Oracle Commerce
                </div>
                <a
                  className="next-step-btn"
                  href="https://www.oracle.com/cx/product-tours/#commerce"
                  target="_blank"
                  tabindex="7"
                >
                  Browse tours
                </a>
              </div>

              <div className="next-step next-step-left">
                <div className="next-step-icon next-step-icon-share"></div>
                <div className="next-step-label">Copy report link</div>
                <div className="next-step-text">
                  Copy, bookmark, or share these results.
                </div>
                <button
                  className="next-step-btn copy-btn"
                  data-clipboard-action="copy"
                  data-clipboard-text={window.location}
                  onClick={confirmCopy}
                  tabindex="8"
                >
                  Copy link
                </button>
                <div className="next-step-confirm">Link copied!</div>
              </div>

              <div className="next-step">
                <div className="next-step-icon next-step-icon-contact"></div>
                <div className="next-step-label">Contact us</div>
                <div className="next-step-text cheat-wide">
                  Talk to a team member about Oracle Commerce
                </div>
                <a
                  className="next-step-btn"
                  href="https://www.oracle.com/cx/sales/contact.html"
                  target="_blank"
                  tabindex="9"
                >
                  Contact us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="report-section report-section-footer">
        <div className="report__content">
          <div className="report-section-footer-content">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/"
              className="report-section-footer-link"
            >
              © 2022 Oracle
            </a>
            <span className="Footer__line"></span>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/"
              className="report-section-footer-link"
            >
              Privacy/Do Not Sell My Info
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              id="teconsent"
              className="report-section-footer-link"
            ></a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising"
              className="report-section-footer-link last-link"
            >
              Ad Choices
            </a>
          </div>
          <div className="social-links">
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.youtube.com/user/oraclecx`}
              className="Socials__icon Socials__icon--5"
            ></a>
            <a
              rel="noreferrer"
              href={`https://www.linkedin.com/showcase/oracle-cx`}
              className="Socials__icon Socials__icon--4"
              target="_blank"
            ></a>
            <a
              rel="noreferrer"
              href={`https://twitter.com/OracleCX`}
              className="Socials__icon Socials__icon--3"
              target="_blank"
            ></a>
            <a
              rel="noreferrer"
              href={`https://www.facebook.com/OracleCustomerExperience/`}
              target="_blank"
              className="Socials__icon Socials__icon--2"
            ></a>
          </div>
          <div className="o-tag"></div>
        </div>
      </section>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChooseQuestions: (role, lang) =>
      dispatch(actionCreators.choose_questions(role, lang)),
    onInitScores: (scrz) => dispatch(actionCreators.init_scores(scrz)),
    onToggleDemo: () => dispatch(actionCreators.toggle_demo()),
  };
};

const mapStateToProps = (state) => {
  return {
    currentLabels: state.questionsReducer.currentLabels,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);
